import { IonRouterOutlet } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import React, { Component } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import store from '../../store'
import { transitionAnimation } from '../../config/transition-animation'

interface ProviderProps {}

export default class Provider extends Component<ProviderProps> {
  render () {
    return (
      <ReduxProvider store={store}>
        <IonReactRouter>
          <IonRouterOutlet animated animation={transitionAnimation}>
            {this.props.children}
          </IonRouterOutlet>
        </IonReactRouter>
      </ReduxProvider>
    )
  }
}
